import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import User from '../pages/User/User';

const Navbar = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const isActive = (path) => location.pathname === path;
	const [profileImage, setProfileImage] = useState('/avatars/deer.png');
	const [loginCard, setLoginCard] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const adminImage = '/avatars/admin.png';

	const images = [
		"bear", "cat", "chicken", "deer", "dog",
		"eagle", "giraffe", "meerkat", "panda", "sealion",
		"lion", "cow", "dragon", "duck", "hippopotamus",
		"koala", "wolf", "fox", "rabbit", "monkey", "fish", "wrabbit"
	];

	const getRandomImage = () => {
		const randomIndex = Math.floor(Math.random() * images.length);
		setProfileImage(`/avatars/${images[randomIndex]}.png`);
	}
	const token = localStorage.getItem('token');
	const isAdmin = localStorage.getItem('adminToken');
	const userName = localStorage.getItem('userName');

	const handleLogin = () => {
		setLoginCard(true);
	}
	const handleLogout = () => {
		localStorage.clear();
		navigate('/');
	};

	return (
		<nav className="bg-gray-900 text-white">
			<div className="flex justify-between items-center lg:py-6 lg:px-16 px-10 py-4">

				<div className="lg:text-xl text-sm font-bold">SRI SEETHA RAMA SEVA SADAN</div>
				<ul className="lg:flex hidden gap-5">
					<Link
						className={`${isActive("/") ? "text-white underline underline-offset-4" : "text-gray-400"
							} transition-colors`}
						to="/"
					>
						Home
					</Link>
					<Link
						className={`${isActive("/about") ? "text-white underline underline-offset-4" : "text-gray-400"
							} transition-colors`}
						to="/about"
					>
						About
					</Link>
					<Link
						className={`${isActive("/articles") ? "text-white underline underline-offset-4" : "text-gray-400"
							} transition-colors`}
						to="/articles"
					>
						Articles
					</Link>
					<Link
						className={`${isActive("/contact") ? "text-white underline underline-offset-4" : "text-gray-400"
							} transition-colors`}
						to="/contact"
					>
						Contact Us
					</Link>
				</ul>
				<div className="lg:hidden flex gap-2">
					{token &&
						<img
							src={profileImage}
							alt="Profile"
							className="w-10 h-10 rounded-full mr-2"
						/>
					}
					<button
						className="block text-gray-600 focus:outline-none"
						onClick={() => setIsMenuOpen(!isMenuOpen)}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-6 w-6"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								d="M4 6h16M4 12h16m-7 6h7"
							/>
						</svg>
					</button>
				</div>

				{token ? (
					<div className="hidden lg:flex items-center space-x-4">
						<img src={profileImage} alt="Profile" className="w-10 h-10 rounded-full" />
						<span className="font-semibold">{userName}</span>
						<button
							onClick={handleLogout}
							className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md"
						>
							Logout
						</button>
					</div>
				) : isAdmin ? (
					<div className="hidden lg:flex items-center space-x-4">
						<img src={adminImage} alt="Admin Profile" className="w-10 h-10 rounded-full" />
						<span className="font-semibold">Admin</span>
						<button
							onClick={handleLogout}
							className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md"
						>
							Logout
						</button>
					</div>
				) : (
					<button
						onClick={() => {
							getRandomImage();
							handleLogin();
						}}
						className="hidden lg:block px-4 py-2 font-medium text-black bg-white border border-black rounded-md hover:bg-gray-700 hover:text-white transition"
					>
						Login
					</button>
				)}
			</div>
			<div
				className={`lg:hidden transition-all duration-300 ease-in-out overflow-hidden ${isMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
					}`}
			>
				<div className="px-4 py-2 space-y-4 text-center bg-gray-900 shadow-md">
					<Link
						to="/"
						className={`${isActive("/") ? "text-white underline underline-offset-8" : "text-gray-600"
							} hover:text-white block`}
						onClick={() => setIsMenuOpen(false)}
					>
						Home
					</Link>
					<Link
						to="/about"
						className={`${isActive("/about") ? "text-white underline underline-offset-8" : "text-gray-600"
							} hover:text-white block`}
						onClick={() => setIsMenuOpen(false)}
					>
						About
					</Link>
					<Link
						to="/articles"
						className={`${isActive("/articles") ? "text-white underline underline-offset-8" : "text-gray-600"
							} hover:text-white block`}
						onClick={() => setIsMenuOpen(false)}
					>
						Articles
					</Link>
					<Link
						to="/contact"
						className={`${isActive("/contact") ? "text-white underline underline-offset-8" : "text-gray-600"
							} hover:text-white block`}
						onClick={() => setIsMenuOpen(false)}
					>
						Contact
					</Link>
					{!token ? (
						<button
							onClick={() => {
								handleLogout();
								setIsMenuOpen(false);
							}}
							className="w-fit bg-red-500 text-white px-4 py-2 rounded-lg"
						>
							Logout
						</button>
					) : (
						<button
							onClick={() => {
								getRandomImage();
								handleLogin();
								setIsMenuOpen(false);
							}}
							className="px-4 py-2 font-medium text-black bg-white border border-black rounded-md hover:bg-gray-700 hover:text-white transition"
						>
							Login
						</button>
					)}
				</div>
			</div>
			{loginCard && <User onClose={() => setLoginCard(false)} />}
		</nav>
	);

};

export default Navbar;
